module.exports = __webpack_public_path__ + "img/pic3.43292cdd.png";